import { useState } from "react";
import LoadingAnimation from "@assets/svg/LoadingAnimation";
import { markUnmarkFavoriteMatchedJobs } from "@endpoints/job.service";
import dayjs from "@lib/dayjs";
import { useSnackbar } from "notistack";
import AnimatedCircleProgress from "@components/AnimatedCircleProgress";
import { NavLink } from "react-router-dom";
import { StarIcon } from "lucide-react";
import StarFilledIcon from "@assets/svg/StarFilledIcon";

const JobCard = ({ data, onClick }) => {
    const { enqueueSnackbar } = useSnackbar()
    const [isMarkedFavorite, setIsMarkedFavorite] = useState(data?.isMarkFavorite)
    const [isMarking, setIsMarking] = useState(false)

    const isAspiration = data?.tag === 'Aspiration'

    const handleMarkUnmarkFavorite = async () => {
        try {
            setIsMarking(true)
            await markUnmarkFavoriteMatchedJobs({
                isMarkFavorite: !isMarkedFavorite,
                matchId: data?._id,
                tag: data?.tag
            })
            setIsMarkedFavorite((prev) => !prev)
        } catch (error) {
            enqueueSnackbar(error, { variant: 'error' })
        } finally {
            setIsMarking(false)
        }
    }

    return (
        <NavLink
            to={"/job-matches-details"}
            state={{ item: data }}
            onClick={onClick}
            className="grid grid-cols-[0.6fr_2fr_0.25fr] gap-28 items-center py-6 border-b pl-2 hover:bg-gray-50"
        >
            <div className="flex flex-col gap-2.5 pb-3.5">
                <span className="text-xs font-medium text-primary bg-gray-50 rounded-md py-2 px-4 border text-center w-max">
                    {isAspiration ? 'Aspirations' : 'Profile'} Match
                </span>
                <span className="text-xs font-medium text-primary">
                    {data?.refNo || 'JO-ABC123'}
                </span>
                <span className="text-xs font-medium text-primary">
                    Location: &nbsp;&nbsp;London
                </span>
                <span className="text-xs font-medium text-primary">
                    Job Type: &nbsp;&nbsp;Full-Time
                </span>
            </div>

            <div className="flex items-center gap-8 h-full w-full">
                <div className="flex flex-col gap-4 flex-1">
                    <span className="text-xs font-bold text-primary text-center">
                        {data?.jobTitle}
                    </span>
                    <div className="flex flex-col gap-1.5">
                        <div className="flex items-center gap-5">
                            <span className="text-xs text-light-black italic">
                                {dayjs(data?.latestTracker?.updatedAt).format("hh:mm a")}
                            </span>
                            <span className="text-xs text-light-black italic">
                                {dayjs(data?.latestTracker?.updatedAt).format("DD MMM YYYY")}
                            </span>
                        </div>
                        <div className="flex flex-col border border-gray-200 bg-gray-50 rounded-md p-3 gap-1 h-[3.5rem] justify-center">
                            <span className="text-xs font-medium text-primary">
                                Latest Activity : {data?.latestTracker?.status || 'N/A'}
                            </span>
                        </div>
                    </div>
                </div>

                <div className="flex flex-col gap-3.5 h-full justify-end pb-3.5">
                    <span className="text-xs text-light-black">Agency</span>
                    <span className="text-xs font-medium text-primary">{data?.recruiterCompanyName || 'N/A'}</span>
                </div>
            </div>

            <div className="flex flex-col items-center h-full">
                <button
                    onClick={(e) => {
                        e?.preventDefault()
                        e?.stopPropagation()
                        handleMarkUnmarkFavorite()
                    }}
                    className="hover:bg-gray-100 rounded-full p-1.5 mr-5"
                >
                    {
                        isMarking ?
                            <LoadingAnimation color="#2e2e2e" /> :
                            isMarkedFavorite ?
                                <StarFilledIcon className={'h-6 w-6'} />
                                :
                                <StarIcon color="#2e2e2e" />
                    }
                </button>
                <div className="flex flex-col h-full justify-end gap-3">
                    <span className="text-xs font-medium text-primary">Matched %</span>
                    <div className="relative">
                        <AnimatedCircleProgress progress={data?.matchingPercentage} />
                    </div>
                </div>
            </div>
        </NavLink>
    );
};

export default JobCard